export const propertyConstants = {
  ALL_PROPERTY_TYPES: "ALL_PROPERTY_TYPES",
  ALL_VIEW_TYPES: "ALL_VIEW_TYPES",
  USER_PROPERTY_TYPES: "USER_PROPERTY_TYPES",
  ALL_FRESH_PROPERTY: "ALL_FRESH_PROPERTY",
  ALL_RECOMMENDED_PROPERTY: "ALL_RECOMMENDED_PROPERTY",
  ALL_RECOMMENDED_PROPERTY_BUTTON: "ALL_RECOMMENDED_PROPERTY_BUTTON",
  ALL_FAVOURITES_PROPERTY: "ALL_FAVOURITES_PROPERTY",
  USER_FAVOURITES_PROPERTY: "USER_FAVOURITES_PROPERTY",
  GET_PROPERTY_DETAIL_BY_ID: "GET_PROPERTY_DETAIL_BY_ID",
  FAVOURITE_PROPERTY: "FAVOURITE_PROPERTY",
  INTERESTED_PROPERTY: "INTERESTED_PROPERTY",
  CREATE_PROPERTY: "CREATE_PROPERTY",
  ALL_PROPERTIES: "ALL_PROPERTIES",
  ALL_PROPERTIES_PAGINATION: "ALL_PROPERTIES_PAGINATION",
  PROPERTY_ID: "PROPERTY_ID",
};

export const PROPERTY_LIMIT_EXCEEDED_MESSAGE =
  "The agent subscription is expired or exceeded the allowed property limit. Are you sure to update the property status?";

export const propertySortingSelectOptions = [
  { id: 1, label: "Latest", value: "id desc" },
  { id: 2, label: "Oldest", value: "id asc" },
  { id: 3, label: "Active", value: "status desc" },
  { id: 4, label: "Inactive", value: "status asc" },
  { id: 5, label: "Most liked", value: "likes desc" },
  { id: 6, label: "Most viewed", value: "views desc" },
];
